import React from "react";
import { isDesktop, toolbarStyles } from "../utils";
import FontSelector from "./components/FontSelector";
import HAlignment from "./components/HAlignment";
import TextColorSelector from "./components/TextColorSelector";
import TextSizeSelector from "./components/TextSizeSelector";
import VAlignment from "./components/VAlignment";
import { useAppSelector } from "../../../hook/redux";
import TextGeneratorButton from "./components/TextGeneratorButton";

function TextEditor( { canvas } ) {
  const { isTextGenerator } = useAppSelector( ( state ) => state.editor.currentData.paramGeneral );
  const desktop = isDesktop();


  return (
  <div
    style={ desktop ? toolbarStyles.desktop.container : toolbarStyles.mobile.container }
    className="d-flex mx-auto bg-white h-md-100"
    data-test="layout-menu-image"
  >
    <div
      style={ desktop ? toolbarStyles.desktop.iconsWrapper : toolbarStyles.mobile.iconsWrapper }
      className="icons-toolbar h-md-100"
    >
      <FontSelector />
      <TextSizeSelector />
      <TextColorSelector />
      <VAlignment canvas={ canvas } />
      <HAlignment canvas={ canvas } />
      {/*<ZoomEditor />*/}
      { isTextGenerator && <TextGeneratorButton /> }
    </div>
  </div>
)
  ;
}

export default TextEditor;